import apiClient from "../api-client";
import { handleApiError } from "../../utils/handle-api-error";

export const updateConversation = async (
  conversationId: string,
  data: any
): Promise<any> => {
  try {
    const response = await apiClient.put<any>(`/conversation`, data);
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

export const deleteConversation = async (
  conversationId: string
): Promise<any> => {
  try {
    const response = await apiClient.delete<any>(
      `/conversation/${conversationId}`
    );
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};
